<template>
  <div>
    <template v-if="isBlocked === true">
      <div class="user-selector" :class="{ 'my-input-disabled': isBlocked === true }">
        <div class="users">
          <i class="mdi mdi-account-supervisor-outline"></i>
        </div>
        <div v-for="user in selectedUsers" :key="user.id" class="user-item">
          <app-avatar-admin :name="user.name" :admin="getAdmin(user.id)" class="avatar-mini avatar-md" />
          {{ user.name | firstAndLast  }}
        </div>
      </div>
    </template>
    <template v-else>
      <div @click="toggleDropdown" class="user-selector">
        <div class="users">
          <i class="mdi mdi-account-supervisor-outline"></i>
        </div>
        <div v-for="user in selectedUsers" :key="user.id" class="user-item">
          <app-avatar-admin :name="user.name" class="avatar-mini  avatar-md" :admin="getAdmin(user.id)"/>
          {{ user.name | firstAndLast }}
        </div>
      </div>
      <div v-if="dropdownVisible" class="dropdown">
        <div class="pre-input">
          <input type="text" placeholder="Procurar um usuário..." v-model="search"
            class="search-input form-control mb-3" />
        </div>
        <ul class="list-group overflow-y" v-if="selectedUsers.length > 0">
          <li class="list-group-item active" aria-current="true">Atribuídos</li>
          <li v-for="user in selectedUsers" :key="user.id" class="list-group-item">
            <app-avatar-admin :name="user.name" class="avatar-mini" />
            <span>{{ user.name | firstAndLast }}</span>
            <button type="button" class="btn btn-danger ml-auto remove-btn" @click.stop="removeUser(user)">
              <i class="mdi mdi-close align-middle"></i>
            </button>
          </li>
        </ul>
        <ul class="list-group overflow-y" v-if="filteredUsers.length > 0">
          <li class="list-group-item active" aria-current="true">Sugestões</li>
          <li v-for="user in filteredUsers" :key="user.id" @click="addUser(user)" class="list-group-item">
            <app-avatar-admin :name="user.name" class="avatar-mini" />
            <span>{{ user.name | firstAndLast }}</span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin.vue";

export default {
  components: {
    AppAvatarAdmin
  },
  data() {
    return {
      dropdownVisible: false,
      search: '',
      selectedUsers: [...this.preSelectedUsers]
    };
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    preSelectedUsers: {
      type: Array,
      default: () => []
    },
    userAdmin: { type: [Number, String], required: false }
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
    filteredUsers() {
      const searchTerm = this.search.toLowerCase();
      return this.users.filter(user => {
        const isAlreadySelected = this.selectedUsers.some(selected => selected.id === user.id);
        const matchesSearch = user.name.toLowerCase().includes(searchTerm);
        return !isAlreadySelected && matchesSearch;
      });
    }
  },
  methods: {
    getAdmin(id){
      let realUser = this.users.find(e => e.id === id)
      return realUser.pivot.is_admin;
    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    addUser(user) {
      this.selectedUsers.push(user);
      this.$emit('userAdded', user);
    },
    removeUser(user) {
      this.selectedUsers = this.selectedUsers.filter(selected => selected.id !== user.id);
      this.$emit('userRemoved', user);
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownVisible = false;
      }
    }
  },
  mounted() {
    document.addEventListener("mousedown", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
};
</script>

<style scoped>
.pre-input {
  padding: 15px;
}

.user-container {
  position: relative;
}

.avatar-md{
  width: 1.6rem;
  height: 1.6rem;
  font-size: 10px;
}

.user-selector {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: auto;
  min-height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 22px;
}

.user-selector>div.users {
  background: #fff;
  width: 40px;
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.user-selector>div.users>i {
  margin: 0 auto;
}

.user-display {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.dropdown {
  border: 1px solid #ddd;
  padding: 0px;
  background: white;
  position: absolute;
  top: 41px;
  z-index: 10;
  width: 350px;
  height: 300px;
  overflow-y: auto;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.dropdown>div>strong {
  background: #f1f2f4;
}

.search-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0px !important;
}

.assigned-section,
.suggestions-section {
  margin-bottom: 15px;
}

.user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px 0px 0px;
  cursor: pointer;
  font-size: 16px;
}

.remove-btn {
  padding: 0px;
  font-size: 14px;
  line-height: 14px;
  height: 20px;
  width: 20px;
  border-radius: 4px;
}


.list-group-item {
  padding: 10px 20px;
}

.list-group-item.active,
.list-group-item {
  border-radius: none !important;
}

.list-group-item>span {
  padding-top: 5px;
}

.list-group-item:first-child {
  background: #f1f2f4;
  border-color: #f1f2f4;
  color: #000;
  border-radius: none !important;
}

.list-group-item:not(.active):hover {
  color: #000;
  cursor: pointer;
}

.list-group-item {
  align-items: center;
  display: flex;
  flex-direction: row;
}


ul.overflow-y {
  height: auto;
  max-height: 200px;
  overflow-y: auto;
}

.list-group-item>button {
  margin-left: auto;
}

.list-group li {
  min-height: auto !important;
}
</style>